import styled from "styled-components"

export const SectionCnpHoldingVideo = styled.section(({ theme }) => ({
    padding: "40px 16px",

    [theme.breakpoint.lg()]: {
        padding: "60px 112px",
    },
}))

export const ContainerCnpHoldingVideo = styled.div(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    gridTemplateColumns: "1fr 2fr",
    gap: "64px",
    alignSelf: "stretch",
    flexDirection: "column",

    [theme.breakpoint.lg()]: {
        display: "grid",
    },

}))

export const ContentCnpHoldingVideo = styled.div(() => ({
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: "32px",
}))

export const TitleCnpHoldingVideo = styled.h2(({ theme }) => ({
    fontSize: "32px",
    fontWeight: 700,
    lineHeight: "150%",
    color: theme.color.brandPrimary.light,
    margin: 0,

    [theme.breakpoint.lg()]: {
        fontSize: "40px",
    },
}))

export const ParagraphCnpHoldingVideo = styled.p(({ theme }) => ({
    fontSize: "18px",
    fontWeight: 500,
    lineHeight: "160%",
    color: theme.color.neutral["02"],
    margin: 0,

    [theme.breakpoint.lg()]: {
        fontSize: "20px",
    },
}))